import { InputProps, SelectProps, TableProps } from '@gate/gui'
import styled from 'styled-components'
import { smStyle } from '../Adapter'

export const BaseTableStyled = styled.div<{
  colWidths?: string[]
}>`
  border-radius: 8px;
  box-sizing: border-box;

  /** 解决表格tooltip遮挡问题 */
  .gui-mantine-rtl-Table-dataRow,
  .mantine-Table-dataRow {
    cursor: pointer;
    transition: all 0.01s;

    &:hover {
      transition: all 0;

      &::after {
        display: none !important;
      }
    }
  }

  /** 表头每一项 */
  .gui-table-th,
  .mantine-Table-dataItem,
  .mantine-Table-titleItem {
    overflow: visible;
    z-index: 100;

    .mantine-TableText-root {
      font-weight: 400;
      color: var(--color-text-3);
      font-size: 14px;
    }

    ${({ colWidths }) => {
      if (!colWidths?.length) return ``
      return colWidths.map(
        (w, i) => `
        &:nth-child(${i + 1}) {
          width: ${w};
          min-width: ${w};
        }
      `
      )
    }}
  }

  .mantine-Table-titleItem {
    & > div {
      background-color: var(--color-neutral-2);
    }
  }
  .gui-mantine-rtl-Table-titleItem {
    .gui-mantine-rtl-TableText-root {
      font-weight: 400;
      color: var(--color-text-1);
    }

    ${({ colWidths }) => {
      if (!colWidths?.length) return ``
      return colWidths.map(
        (w, i) => `
        &:nth-child(${i + 1}) {
          width: ${w};
          box-sizing: border-box;
        }
      `
      )
    }}
    & > div {
      background-color: var(--color-neutral-2);
    }
  }

  /** loading */
  .mantine-LoadingOverlay-root {
    padding-top: 80px;
  }

  .mantine-Table-root {
    margin-bottom: 8px;
    position: sticky;
  }

  .mantine-Table-dataItem {
    font-size: 16px;
    color: var(--color-text-1);

    span {
      font-weight: 500;
    }
  }
`

export const BaseTableStyles: TableProps['styles'] = {
  wrapper: {
    borderRadius: 8,
    width: '100%',
    overflow: 'auto',

    '::-webkit-scrollbar': {
      width: '4px',
      height: '4px',
    },
  },
  titleRow: {
    background: 'var(--color-card-1)',
    height: 40,
  },
  dataRow: {
    height: 80,
    '&:hover': {
      '&::after': 'none',
    },
    [`${smStyle}`]: {
      '&:hover': {
        backgroundColor: 'var(--color-neutral-2)',
        '& >td': {
          backgroundColor: 'var(--color-neutral-2) !important',
        },
      },
    },
  },
  titleItem: {
    background: 'var(--color-neutral-2) !important',
    '.mantine-TableTitle-root': {
      padding: '0 6px',
    },
    ':first-of-type .mantine-TableTitle-root': {
      padding: '0 6px 0 12px',
    },
    ':last-child .mantine-TableTitle-root': {
      padding: '0 12px 0px 6px',
      justifyContent: 'flex-end',
    },

    '.gui-mantine-rtl-TableTitle-root': {
      padding: '0 6px',
    },
    ':first-of-type .gui-mantine-rtl-TableTitle-root': {
      padding: '0 6px 0 12px',
    },
    ':last-child .gui-mantine-rtl-TableTitle-root': {
      padding: '0 12px 0px 6px',
      justifyContent: 'flex-end',
    },
  },
  dataItem: {
    padding: '0 6px',

    ':first-of-type': {
      padding: '0 6px 0 12px',
    },

    ':last-child': {
      padding: '0 12px 0px 6px',
      width: '100%',
      justifyContent: 'flex-end',
      textAlign: 'right',
    },
  },
}

export const SelectStyles: SelectProps['styles'] = {
  input: {
    color: 'var(--color-text-3)',
    fontSize: '12px',
    fontWeight: 400,
    padding: '6px 8px',
    width: '120px',
    "&[data-locale='zh']": {
      width: '80px',
    },
    "&[data-locale='en']": {
      width: '110px',
    },
    "&[data-locale='vi']": {
      width: '128px',
    },
    "&[data-locale='zh-tw']": {
      width: '80px',
    },
    "&[data-locale='es']": {
      width: '134px',
    },
    "&[data-locale='ru']": {
      width: '140px',
    },
    "&[data-locale='fr']": {
      width: '115px',
    },
    "&[data-locale='de']": {
      width: '120px',
    },
    "&[data-locale='pt']": {
      width: '134px',
    },
    "&[data-locale='pt-br']": {
      width: '134px',
    },
    "&[data-locale='th']": {
      width: '105px',
    },
    "&[data-locale='ar']": {
      width: '105px',
    },
    "&[data-locale='uk']": {
      width: '135px',
    },
  },
  rightSection: {
    display: 'none',
  },
  item: {
    fontSize: '12px',
    fontWeight: 400,
    padding: '6px 2px',

    icon: {
      display: 'none',
    },
  },
  dropdown: {
    '.mantine-GateSelect-itemsWrapper': {
      padding: '4px !important',
    },

    '.mantine-Select-item::after': {
      display: 'none',
    },
  },
}

export const InputStyles: InputProps['styles'] = {
  wrapper: {
    margin: '0 8px',
  },
  input: {
    background: 'transparent !important',
    '&:focus:not([aria-invalid="true"])': {
      borderColor: 'var(--color-divider-5)',
    },
    '&:hover': {
      color: 'var(--color-text-5)',
    },
  },
}
